export default {
  //#region ComplexityParameters
  fetchAllComplexityParameters({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("cashflow/decarbonization/complexityParameters/findAll")
        .then((response) => {
          commit('SET_COMPLEXITY_PARAMETERS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addComplexityParameter({ commit }, complexityParameter) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/complexityParameters/create', { complexityParameter })
        .then((response) => {
          commit('ADD_COMPLEXITY_PARAMETER', Object.assign(complexityParameter, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  updateComplexityParameter({ commit }, complexityParameter) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/complexityParameters/edit', { complexityParameter })
        .then((response) => {
          commit('UPDATE_COMPLEXITY_PARAMETER', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  removeComplexityParameter({ commit }, id) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/complexityParameters/delete', { id })
        .then((response) => {
          commit('REMOVE_COMPLEXITY_PARAMETER', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },
  //#endregion

  //#region EnergySourceUnitConversions
  fetchAllEnergySourceUnitConversions({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("CashFlow/Decarbonization/EnergySourceUnitConversions/FindAll")
        .then((response) => {
          commit('SET_ENERGY_SOURCE_CONVERSION_UNITS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addEnergySourceUnitConversion({ commit }, energySourceUnitConversion) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('CashFlow/Decarbonization/EnergySourceUnitConversions/Create', { energySourceUnitConversion })
        .then((response) => {
          commit('ADD_ENERGY_SOURCE_CONVERSION_UNIT', Object.assign(energySourceUnitConversion, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  updateEnergySourceUnitConversions({ commit }, energySourceUnitConversion) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('CashFlow/Decarbonization/EnergySourceUnitConversions/Edit', { energySourceUnitConversion })
        .then((response) => {
          commit('UPDATE_ENERGY_SOURCE_CONVERSION_UNIT', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  removeEnergySourceUnitConversions({ commit }, id) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('CashFlow/Decarbonization/EnergySourceUnitConversions/Delete', { id })
        .then((response) => {
          commit('REMOVE_ENERGY_SOURCE_CONVERSION_UNIT', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },

  //#endregion
  
  //#region GridEfficiencyTemplates
  fetchAllGridEfficiencyTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("cashflow/decarbonization/gridEfficiencyTemplates/findAll")
        .then((response) => {
          commit('SET_GRID_EFFICIENCY_TEMPLATES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addGridEfficiencyTemplate({ commit }, gridEfficiencyTemplate) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/gridEfficiencyTemplates/create', { gridEfficiencyTemplate })
        .then((response) => {
          commit('ADD_GRID_EFFICIENCY_TEMPLATE', Object.assign(gridEfficiencyTemplate, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },
  updateGridEfficiencyTemplate({ commit }, gridEfficiencyTemplate) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/gridEfficiencyTemplates/edit', { gridEfficiencyTemplate })
        .then((response) => {
          commit('UPDATE_GRID_EFFICIENCY_TEMPLATE', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  removeGridEfficiencyTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/gridEfficiencyTemplates/delete', { id })
        .then((response) => {
          commit('REMOVE_GRID_EFFICIENCY_TEMPLATE', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },
  duplicateGridEfficiencyTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('cashflow/decarbonization/gridEfficiencyTemplates/duplicate', { id })
        .then((response) => {
          commit('DUPLICATE_GRID_EFFICIENCY_TEMPLATE', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  }
  //#endregion
}
